var _g, _g2, _g3, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfidCircleIncorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6300_10914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.8301 8.09088H66.0028C34.0205 8.09089 8.09375 34.0177 8.09375 66C8.09375 97.9823 34.0205 123.909 66.0028 123.909C97.9851 123.909 123.912 97.5657 123.912 65.5834C123.912 34.058 98.3555 8.09089 66.8301 8.09088Z",
    fill: "url(#paint0_linear_6300_10914)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_6300_10914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.9286 1H66C30.1015 1.00001 1 30.1015 1 66C1 101.899 30.1015 131 66 131C101.899 131 131 101.431 131 65.5324C131 30.1467 102.314 1.00001 66.9286 1Z",
    fill: "url(#paint1_linear_6300_10914)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_6300_10914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.9286 1H66C30.1015 1.00001 1 30.1015 1 66C1 101.899 30.1015 131 66 131C101.899 131 131 101.431 131 65.5324C131 30.1467 102.314 1.00001 66.9286 1Z",
    fill: "url(#paint2_linear_6300_10914)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9286 1H66C30.1015 1.00001 1 30.1015 1 66C1 101.899 30.1015 131 66 131C101.899 131 131 101.431 131 65.5324C131 30.1467 102.314 1.00001 66.9286 1Z",
    stroke: "url(#paint3_linear_6300_10914)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.4503 55.202C89.1169 52.5354 89.1169 48.212 86.4503 45.5454C83.7837 42.8788 79.4603 42.8788 76.7937 45.5454L65.4048 56.9342L54.016 45.5454C51.3494 42.8788 47.0259 42.8788 44.3593 45.5454C41.6927 48.212 41.6927 52.5354 44.3593 55.202L55.7482 66.5909L44.3593 77.9797C41.6927 80.6463 41.6927 84.9698 44.3593 87.6364C47.0259 90.303 51.3494 90.303 54.016 87.6364L65.4048 76.2475L76.7937 87.6364C79.4603 90.303 83.7837 90.303 86.4503 87.6364C89.1169 84.9698 89.1169 80.6463 86.4503 77.9797L75.0615 66.5909L86.4503 55.202Z",
    fill: "url(#paint4_linear_6300_10914)",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6300_10914",
    x: 3.09375,
    y: 3.09088,
    width: 125.816,
    height: 125.818,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_6300_10914"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_6300_10914",
    x: -7,
    y: -7,
    width: 146,
    height: 146,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_6300_10914"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_6300_10914",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_6300_10914",
    x: -7.5,
    y: -7.5,
    width: 147,
    height: 147,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_6300_10914"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_6300_10914",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6300_10914",
    x1: 127.071,
    y1: 66,
    x2: 77.2124,
    y2: 52.1645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6161",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6300_10914",
    x1: 153.75,
    y1: 14.838,
    x2: 15.6574,
    y2: 50.6934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6161",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6300_10914",
    x1: 153.75,
    y1: 14.838,
    x2: 15.6574,
    y2: 50.6934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6161",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6300_10914",
    x1: 0.999999,
    y1: 81.5,
    x2: 131,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7979",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7979",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6300_10914",
    x1: 49.5622,
    y1: 61.1187,
    x2: 122.07,
    y2: 67.2395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidCircleIncorrect);
export default __webpack_public_path__ + "static/media/bfid-circle-incorrect.adef08223f1432f805f2772e005f414e.svg";
export { ForwardRef as ReactComponent };